import React, { useMemo, useCallback, useState } from 'react';
import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { Button } from '@gouvfr-lasuite/cunningham-react';
import { DropdownMenu } from '@gouvfr-lasuite/ui-kit';

import { useForm } from '../../hooks';
import PopoverHeader from '../../ui/Popover/PopoverHeader';

import styles from './CardMoveStep.module.scss';

const CardMoveStep = React.memo(
  ({ lists, defaultPath, onMove, onTransfer, onBoardFetch, onBack, onClose }) => {
    const [t] = useTranslation();
    // const [isBoardDropdownOpen, setIsBoardDropdownOpen] = useState(false);
    const [isListDropdownOpen, setIsListDropdownOpen] = useState(false);

    const [path, handleFieldChange] = useForm(() => ({
      boardId: null,
      listId: null,
    }));

    const selectedList = lists.find((list) => Number(list.id) === Number(path.listId));
    console.log('selectedList', selectedList);
    console.log('lists', lists);

    const handleListIdChange = useCallback(
      (targetListId) => {
        if (targetListId) {
          handleFieldChange(targetListId, { name: 'listId', value: targetListId });
        }
      },
      [handleFieldChange],
    );

    const handleSubmit = useCallback(
      (event) => {
        event.preventDefault();

        if (!selectedList) {
          return;
        }

        if (selectedList.id !== defaultPath.listId) {
          onMove(selectedList.id);
        }

        onClose();
      },
      [defaultPath.listId, onMove, onClose, selectedList],
    );

    return (
      <>
        <PopoverHeader
          onBack={onBack}
          title={t('common.moveCard', {
            context: 'title',
          })}
        />
        <form onSubmit={handleSubmit}>
          <div className={styles.selectorContainer}>
            <div className={styles.text}>{t('common.list')}</div>
            <DropdownMenu
              name="listId"
              isOpen={isListDropdownOpen}
              onOpenChange={setIsListDropdownOpen}
              options={lists.map((list) => ({
                label: list.name,
                value: list.id,
                key: `list-${list.id}`,
              }))}
              selectedValue={selectedList && [selectedList.id]}
              placeholder={lists.length === 0 ? t('common.noLists') : t('common.selectList')}
              onSelectValue={handleListIdChange}
            >
              <div className={styles.selector}>
                <Button
                  color="brand"
                  variant="bordered"
                  size="small"
                  onClick={() => setIsListDropdownOpen(true)}
                >
                  {selectedList ? selectedList.name : t('common.selectList')}
                </Button>
              </div>
            </DropdownMenu>
          </div>
          {/* )} */}
          <Button
            type="submit"
            disabled={!selectedList} // (selectedBoard && selectedBoard.isFetching !== false) ||
            color="brand"
            variant="primary"
          >
            {t('action.move')}
          </Button>
        </form>
      </>
    );
  },
);

CardMoveStep.propTypes = {
  // boards: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  lists: PropTypes.array.isRequired, // eslint-disable-line react/forbid-prop-types
  defaultPath: PropTypes.object.isRequired, // eslint-disable-line react/forbid-prop-types
  onMove: PropTypes.func.isRequired,
  onTransfer: PropTypes.func.isRequired,
  onBoardFetch: PropTypes.func.isRequired,
  onBack: PropTypes.func,
  onClose: PropTypes.func.isRequired,
};

CardMoveStep.defaultProps = {
  onBack: undefined,
};

export default CardMoveStep;
